<template>
	<div class="card-view">
		<draggable :list="projects" group="people" class="row gutter-md" sort="true" draggable=".draggable" :disabled="!enableSorting" :class="[{ 'draggable-active': enableSorting }, mode === 'guestPlaylist' ? 'q-mb-lg' : 'q-mt-lg']">
			<ProjectCard v-for="project in projects" :key="project.hash_id" :is-sandbox="isSandbox" :project-prop="project" :mode="mode" :user-status="userStatus"></ProjectCard>
		</draggable>
	</div>
</template>

<script>
	// ####################################################################################################################
	// ####################################################################################################################

	import draggable from 'vuedraggable';
	import { mapGetters } from 'vuex';

	import ProjectCard from './ProjectCard.vue';

	export default {
		name: 'ProjectCardsCollection',
		components: {
			draggable,
			ProjectCard
		},

		props: {
			projects: {
				type: Array,
				default() {
					return [];
				}
			},

			mode: {
				type: String,
				default: '',
				validator: value => {
					return ['list', 'playlistEdit', 'playlistView', 'guestPlaylist', 'salesDemo'].includes(value);
				}
			},

			isSandbox: {
				type: Boolean
			},

			enableSorting: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				// projectID: '',
				// showMoreLanguageButtons: false
			};
		},

		computed: {
			...mapGetters({
				// playlist: 'getPlaylist'
			}),

			userStatus() {
				return this.$store.getters.getUserStatus;
			}

			// playlists() {
			// 	return this.$store.getters.getPlaylists;
			// }
		},

		watch: {},
		created() {},
		methods: {}
	};
</script>

<style>
	/* ########## ProjectCardsCollection.vue ########## */
	button.card-dropdown-btn {
		flex-direction: column;
		box-shadow: none;
	}

	.q-btn:not(.disabled, .q-btn-flat, .q-btn-outline, .q-btn-push).active::before,
	.q-btn:not(.disabled, .q-btn-flat, .q-btn-outline, .q-btn-push):active::before {
		box-shadow: none;
	}

	body.desktop .q-focusable:focus .q-focus-helper,
	body.desktop .q-hoverable:hover .q-focus-helper {
		background-color: inherit;
	}

	.card .q-card-title {
		overflow: hidden;
		width: 54%;
		font-size: 16px;
		font-weight: 400;
		letter-spacing: normal;
		line-height: 2.3rem;
		text-overflow: ellipsis;
	}

	.q-card-title-extra {
		position: absolute;
		right: 0;
		align-self: flex-end;
		margin-top: 3px;
		margin-right: 16px;
	}

	.q-card-subtitle p {
		margin: 0;
	}

	.swal2-content strong,
	.swal2-content b {
		font-weight: bold;
	}

	[type='reset'],
	[type='submit'],
	button,
	html [type='button'] {
		appearance: initial;
	}

	div.fab-buttons .q-btn-inner {
		color: white;
	}

	div.fab-buttons {
		top: 0;
		right: 8px;
		height: 56px;
		margin-bottom: -28px;
		text-align: right;
		transform: translateY(-50%);
	}

	.q-btn-fab {
		background-color: #f90;
	}

	div.type {
		position: absolute;
		z-index: 1;
		top: 0;
		margin: 16px;
		color: #f90;
		text-align: left;
	}

	.list div.type {
		margin: 0;
	}

	.brdr {
		border: solid black 1px;
	}

	.q-card-media > img.brdr {
		border: solid black 1px;
	}

	.q-card-media > img {
		position: absolute;
		display: block;
		width: 100%;
		max-width: 100%;
		border: 0;
		inset: 0;
	}

	/* .q-card > div:first-child {
		padding-top: 56.25%;
	} */

	.extra-info {
		display: block;
		width: 100%;
		text-align: right;
	}

	.extra-info div {
		display: inline-block;
	}

	.logo {
		width: 100%;
		height: 25px;
		text-align: right;
	}

	.logo img {
		height: 100%;
	}

	.logo.list {
		text-align: left;
	}

	.q-popover.scroll.animate-popup-up {
		max-width: 450px !important;
	}

	.q-popover.scroll.animate-popup-down {
		max-width: 450px !important;
	}

	.draggable-active .draggable .cursor-pointer,
	.draggable-active .draggable {
		cursor: move !important;
	}
</style>
